<template>
  <div class="page new" :class="banner_top==1?'special':''" v-wechat-title="$route.meta.title">


    <!--轮播图-->
    <div class="swiper-con border-box" style="position: relative;">
      <Swiper :banners="banners" :type="'spot'"></Swiper>
    </div>

    <!--语音景区详情及目录地图切换-->
    <div class="list-tab list-tab2">
      <div @click="tabIntroCurr=1" class="flex" :class="tabIntroCurr==1?'curr':''">景区解说</div>
      <div @click="tabIntroCurr2" class="flex" :class="tabIntroCurr==2?'curr':''">景区简介</div>
    </div>

    <!--语音列表-->
    <div class="voice-box" :class="tabIntroCurr==2?'none':''">
      <!--我的已购-->
      <div class="popularity-recommend" v-if="mylist.length>0">
        <div class="list border-box">
          <div  v-for="(item,index) in mylist" :key="index">
            <div  class="list-box box" @click="goVideoPlay(index,'myList')">
              <div class="block list-img">
                <img class="icon-tx" v-lazy="item.guideheadimg2?item.guideheadimg2:item.guideheadimg" alt="">
              </div>
              <!--右侧语音内容部分-->
              <div class="block flex list-info">
                <div class="list-name guide-name hide">{{item.guidename2?item.guidename2:item.guidename}}</div>
                <div class="list-name guide-name hide" v-if="item.guidetag"><span>{{item.guidetag}}</span></div>
                <div class="list-group hide"><span class="fl hide">{{item.name}}</span></div>
                <div class="sees-num-block clearfix"><div class="label-color"><span>共{{item.sees}}个讲解点</span></div></div>
                <div class="list-group hide" v-if="item.label"><span class="label-color label-type">{{item.label}}</span></div>
                <button class="btn buy-btn buy-btn2" @click.stop="goVideoPlay(index,'myList')">进入收听</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--官方推荐-->
      <div class="popularity-recommend" v-if="tlist.length>0">
        <div class="list border-box">
          <div v-for="(item,index) in tlist" :key="index">
            <div class="list-box box" @click="goVideoPlay(index,'tjList')" v-if="item.bagtype==null ||item.bagtype==0 ">
              <div class="block list-img">
                <img class="icon-tx" v-lazy="item.guideheadimg2?item.guideheadimg2:item.guideheadimg" alt="">
              </div>
              <!--右侧语音内容部分-->
              <div class="block flex list-info">
                <div class="list-name guide-name hide">{{item.guidename2?item.guidename2:item.guidename}}</div>
                <div class="list-name guide-name hide" v-if="item.guidetag"><span>{{item.guidetag}}</span></div>
                <div class="list-group hide"><span class="fl hide">{{item.name}}</span></div>
                <div class="sees-num-block clearfix"><div class="label-color"><span>共{{item.sees}}个讲解点</span></div></div>
                <div class="list-group hide" v-if="item.label"><span class="label-color label-type">{{item.label}}</span></div>
                <button class="btn buy-btn buy-btn2" @click.stop="goVideoPlay(index,'tjList')">进入收听</button>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!--语音列表-->
      <div class="list border-box" :class="siteBrotherList.length>0?'brothers':''" v-if="bagList && bagList.length>0">
        <div class="list-box box" v-for="(item,index) in bagList" :key="index" @click="goVideoPlay(index,'bagList')">
          <div class="block list-img">
            <img class="icon-tx" v-lazy="item.guideheadimg2?item.guideheadimg2:item.guideheadimg" alt="" @click.stop="goVideoPlay(index,'bagList')">
          </div>
          <!--右侧语音内容部分-->
          <div class="block flex list-info">
            <div class="list-name guide-name hide">{{item.guidename2?item.guidename2:item.guidename}}</div>
            <div class="list-name guide-name hide" v-if="item.guidetag"><span>{{item.guidetag}}</span></div>
            <div class="list-group hide"><span class="fl hide">{{item.name}}</span></div>
            <div class="sees-num-block clearfix"><div class="label-color"><span>共{{item.sees}}个讲解点</span></div></div>
            <div class="list-group hide" v-if="item.label"><span class="label-color label-type">{{item.label}}</span></div>
            <button class="btn buy-btn buy-btn2" @click.stop="goVideoPlay(index,'bagList')">进入收听</button>
          </div>
        </div>

        <p class="load-tip" ref="loadtip">{{loadText}}</p>
      </div>

      <!--其他展馆-->
      <div v-if="siteBrotherList.length>0">
        <div class="split-line" style="height: .16rem;"></div>
        <p class="jc-tit border-box">其他关联展馆
          <router-link class="fr" v-if="siteBrotherList.length>1" :to="{path:'/view-detail-group',query: {shopid:shopid,siteid:siteid,sregion:sregion,TimeStamp:TimeStamp,appKey:appKeyA}}">{{siteBrotherTit}}
            <img src="../../assets/back.png" alt="">
          </router-link>
        </p>
        <ul class="zg-ul border-box clearfix">
          <li v-for="(item,index) in siteBrotherList" :key="index" @click="goViewDetail(item.id)" v-if="index<3">
            <img v-lazy="item.logo" alt="">
            <p class="hide">{{item.name}}</p>
          </li>
        </ul>
      </div>
    </div>

    <!--景区详情内容-->
    <div class="tab-scenic-box" :class="tabIntroCurr==1?'none':''">
      <!--门票及开放时间信息-->
      <div class="scenic-padding border-box">
        <div class="scenic-details-info mt13">景区助手：建议游玩时长 {{(shop.routetime=='')||(shop.routetime==null)||(!shop.routetime)?'暂无信息':shop.routetime}}</div>

        <div class="scenic-details-title border-box" style="margin-top: .24rem;">景区信息</div>
        <div class="scenic-details-info mt13" v-if="(shop.info=='')||(shop.info==null)||(!shop.info)">暂无景区信息</div>
        <div class="scenic-details-info mt13" v-html="shop.info" v-else></div>
      </div>

    </div>

    <!--目录弹窗-->
    <div class="alert-box catalogue-box" :class="catalogueCurr==1?'curr':''">
      <div @click="catalogueCurr=0" class="mask"></div>
      <div class="catalogue-item border-box">
        <div class="font34 cor3">讲解点目录</div>
        <div class="catalogue-line"></div>
        <form class="catalogue-input" v-on:submit.prevent="getCatalist()">
          <input class="border-box" :placeholder="shop.name" value="" v-model='inputValue'/>
          <img src="../../assets/icon-search.png" alt="" @click='getCatalist()'>
        </form>
        <div class="catalogue-item-con border-box">
          <div v-for="(item,index) in catalogueRoot" :key="index" @click="spotLink(item.id,shopid)" class="catalogue-name hide">{{item.name}}</div>
        </div>
      </div>
    </div>

    <!--试听结束弹窗新版-->
    <AlertListenEnd  :bag="bag" :couponid="couponid" :extral="extral" @close="closeEnd" v-if="Object.keys(bag).length>0"></AlertListenEnd>

    <!--红包活动弹窗(国庆节日红包)-->
    <AlertRedEnvelope  :redEnvelopes="redEnvelopes" @close="closeEnvelope" v-if="Object.keys(redEnvelopes).length>0"></AlertRedEnvelope>
    <!--红包活动弹窗(普通红包)-->
    <AlertRedEnvelNew  :redEnvelNew="redEnvelNew" @close="closeEnvelope" v-if="Object.keys(redEnvelNew).length>0"></AlertRedEnvelNew>

    <!--红包人物-->
    <AlertPersonEnvelope  :shopid="shopid" :personEnvelopes="personEnvelopes" @close="closeEnvelope" v-if="Object.keys(personEnvelopes).length>0"></AlertPersonEnvelope>

    <!--人物推荐+视频推荐(userTui=2)-->
    <AlertRecommendPerson :userTui="userTui" :shopid="shopid" :recommendPerson="recommendPerson" @close="closeEnvelope" v-if="recommendPerson"></AlertRecommendPerson>
    <!--新年人物推荐-->
    <AlertYearPerson  :shopid="shopid" :recommendYear="recommendYear" @close="closeEnvelope" v-if="recommendYear"></AlertYearPerson>

    <!--提醒用户购买弹窗弹窗-->
    <AlertPayTip @close="closePayTip" :comeForm="0" v-if="buyTip==1"></AlertPayTip>

    <!--海报弹窗-->
    <AlertPoster  :id="spotid" :type="'spot'" @close="closePoster" v-if="posterShow==1"></AlertPoster>

    <audio id="Audio" style="overflow: hidden" src="http://wangchuang-1252493175.coscd.myqcloud.com/jpjs/upload/voice/20181126/iosvoicetest.mp3"></audio>

    <!--关注公众号弹窗-->
    <Focus :focusRes="focusRes" v-on:alert-Focus="closeFocus()" v-if="focusEwmShow==1"></Focus>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>

<script>
  import PhotoSphereViewer from 'photo-sphere-viewer'
  import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
  import { mapState, mapMutations } from 'vuex'
  import Swiper from '../../components/Swiper'
  import {getSpotDetail, getBagTab, getCatalogue, uploadScan, getEnvelope, getUserTui, uploadUserBrowse, getNotice,getViewVr,getVideoList,siteBrother,ScanTip} from "@/service/getData";
  import {wxGetPosition,wxShareme,listenEndOrder, listenTurl, creatOrder, pushOrder} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import AlertListenEnd from '../../components/AlertListenEnd'
  import AlertRedEnvelope from '../../components/AlertRedEnvelope'
  import AlertPersonEnvelope from '../../components/AlertPersonEnvelope'
  import AlertRecommendPerson from '../../components/AlertRecommendPerson'
  import AlertYearPerson from '../../components/AlertYearPerson'
  import AlertRedEnvelNew from '../../components/AlertRedEnvelNew'
  import AlertPayTip from '../../components/AlertPayTip'
  import AlertPoster from '../../components/AlertPoster'
  import Focus from '../../components/Focus'
  import P400 from '../../components/P400'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        code: this.$route.query.code || '', //城市站点id
        siteid:'',//站点id
        sregion:'',//省站点id:430000
        qrcode: '', //是否是扫码
        qid: '', //扫码id
        spotid: this.$route.query.spotid || '', //景点id
        shopid: this.$route.query.shopid || '', //景区id
        userInfo: {}, //用户信息
        inputValue: '',//搜索关键词
        page: 1,
        rows: 10,
        loadText: "数据加载中",

        res: "", //全部数据
        cid: "", //导游筛选
        bagList: [],//解说列表
        total: '',//解说总数
        banners: [], //banner图片或者video
        shop: '',//景点信息
        routes: '',//游玩路线
        mylist: [], //我的购买
        tlist: [],//推荐列表
        tablist: [],//导游分类列表
        tabIntroCurr: 1,//语音、景区详情及目录切换
        catalogueCurr: 0,//目录弹窗
        catalogueRoot: [],//目录弹窗内容
        banner_top: '',
        personEnvelopes: [], //红包人物
        redEnvelopes: [], //国庆红包数据
        redEnvelNew: [], //普通红包数据
        recommendPerson: '', //推荐人物数据
        recommendYear: '', //推荐人物专辑数据+音频
        userTui: '', //推荐弹窗类型
        buyTip: 0, //购买提醒弹窗

        Audio: '', //音频dom
        videoTimer: null, //语音播放计时器
        currIndex: -1, //当前播放音频数组下标
        index1: 0, //当前播放音频数组下标(用来记录currIndex，传值给下订单方法)
        bag:{}, //当前试听的专辑
        extral:{}, //存放下单需要的值
        couponid: '', //优惠券id
        listType: '', //所点击的语音列表类型‘tjList:推荐列表’，‘bagList:其他列表’
        lastListType: '', //记录上一次所点击的语音列表类型‘tjList:推荐列表’，‘bagList:其他列表’

        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',
        posterShow: 0, //分享海报弹窗

        VRlist: [], //VR视频列表
        VRtotal: 0, //VR视频专辑总数
        focusEwmShow:0,//二维码弹窗0：隐藏   1：显示
        focusRes:'',//二维码弹窗数据

        videoList: [], //视频列表
        videoTotal: 0, //视频专辑总数

        siteBrotherList: [], //关联的展区
        siteBrotherTit: '', //关联景区的查看更多标题

        P400: 0, //系统维护中
        PSV: null, //全景图片
        loadPSV: false, //全景是否加载完

        usernote: this.$route.query.usernote || '', //扫码得到的时间戳
      }
    },
    computed: {

    },
    created(){

      this.$loading.show('数据加载中');

      this.spotid = this.$route.query.spotid;
      this.userInfo = getStore("userInfo");
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
        this.sendUserBrowse();
      }else{
        setStore("appKey", {"appKey":""});
      }
      this.siteid = this.$route.query.siteid || getStore("siteid") || "";
      if (this.siteid != "" && this.siteid != null && this.siteid != undefined) {
        setStore("siteid", this.siteid);
        removeStore("sregion")
      }
      this.sregion = this.$route.query.sregion || getStore("sregion") || "";
      if (this.sregion != "" && this.sregion != null && this.sregion != undefined) {
        setStore("sregion", this.sregion);
        this.siteid = '';
        removeStore("siteid")
      }

      this.getTablist();
      this.getCatalist();
      this.getVideoList();
      this.siteBrother();

      this.qrcode = this.$route.query.qrcode;
      this.qid = this.$route.query.qid;
      if(this.qid){
        setStore("qid", {"qid":this.qid});
      }
      if(this.qrcode){
        setStore("spotid", {"spotid":this.spotid});
        let self = this;
        wxGetPosition(function(res){
          self.sendScan(res.latitude,res.longitude);
        });
      }

      //红包活动
      if(this.shopid!=69 || (this.shopid==69&&this.qid==134)){
        this.getActivity();
      }
      this.getBuyNotice();

      if(this.usernote){
        this.getScanTip();
      }

      window.addEventListener("scroll",this.handleFun)
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun);
      if(this.videoTimer){
        clearInterval(this.videoTimer);
        this.currIndex = -1;
        this.bagList[this.index1].isplay = 0;
        this.tlist[this.index1].isplay = 0;
        this.bag = {};
      }
      if (this.PSV) {
        this.PSV.destroy()
      }
    },
    methods: {

      //获取语音+景区+推荐信息
      async initData(page){
        let res = await getSpotDetail({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          page: page,
          rows: this.rows,
          spotid: this.spotid,
          cid: this.cid,
          usernote: this.usernote || ''
        });

        if (res.errcode === "00000"){
          this.$loading.hide();

          this.res = res.data;
          this.mylist = res.data.mylist;
          if(this.qrcode && res.data.isturn && res.data.mylist.length>0){
            this.$router.push({
              path: `/video-play-nx?${'id='+this.mylist[0].id+'&spotid='+this.mylist[0].spotid+'&shopid='+this.shopid+'&isback=1&form=spot&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
            });
          }

          this.focusRes = res.data;
          this.banners = res.data.allimg;
          this.shop = res.data.shop;
          this.shop.showSellprice = res.data.showSellprice;
          this.routes = res.data.routes
          for(var i=0; i<res.data.tlist.length; i++){
            res.data.tlist[i].isplay = 0;
            res.data.tlist[i].toaTime = '';
            res.data.tlist[i].resTime = '';
          }
          this.tlist = res.data.tlist
          this.banner_top = res.data.banner_top

          this.total = res.data.total
          for(var i=0; i<res.data.root.length; i++){
            res.data.root[i].isplay = 0;
            res.data.root[i].toaTime = '';
            res.data.root[i].resTime = '';
          }
          let bagList = res.data.root
          if (page >= Math.ceil(this.total / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (bagList.length > 0) {
            this.bagList = [...this.bagList, ...bagList];
          } else {
            if (page == 1) {
              this.bagList = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }

          var share = res.data.share;
          let link = '/spot-detail-nx?spotid='+ this.spotid +'&shopid='+ this.shopid +'&siteid='+ this.siteid + '&sregion='+ this.sregion  +'&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey);
          if(share == null){
            let title = '金牌解说 | ' + this.shop.name;
            let desc = '历史会说话！金牌解说为您讲解' + this.shop.name + '的历史故事';
            let img = this.banners[0];
            wxShareme(title,desc,img,link);
          }else {
            wxShareme(share.title,share.desc,share.logo,link);
          }

          this.$route.meta.title = this.shop.name;

          this.getVr();


          let self = this;
          setTimeout(function(){
            self.$nextTick(function() {
              var dom = document.getElementById("tab-intro");
              if(dom && dom != null){
                window.scrollTo(0,self.offSet(dom));
              }
            });
          },3500);

        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }
      },

      offSet(curEle){
        var totalTop = null;
        var par = curEle.offsetParent;
        //首先把自己本身的相加
        totalTop += curEle.offsetTop;
        //现在开始一级一级往上查找，只要没有遇到body，我们就把父级参照物的边框和偏移相加
        while (par){
          //把父级参照物的偏移相加
          totalTop += par.offsetTop;
          par = par.offsetParent;
        }
        return totalTop;
      },

      //获取VR数据
      async getVr(){
        let res = await getViewVr({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          shopid: this.shopid,
          spotid: '',
          page:1,
          rows:50
        });
        if(res.errcode == '00000'){
          if(res.data.root != null && res.data.root.length > 0){
            this.VRlist = res.data.root;
            this.VRtotal = res.data.total;

            var self = this;
            this.$nextTick(function(){
              if(self.VRlist[0].vrimg && self.VRlist[0].vrimg != '' && self.VRlist[0].vrimg != null && (self.shopid!=852) && self.res.vr2bag!=1){
                self.showPhotoVR(self.VRlist[0].vrimg,'video-vr-img');
              }
            })
          }
        }
      },

      //获取视频数据
      async getVideoList(){
        let res = await getVideoList({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          shopid: this.shopid,
          orderby: 'tui',
        });
        if(res.errcode == '00000'){
          if(res.data.data != null && res.data.data.length > 0){
            this.videoList = res.data.data;
            this.videoTotal = res.data.total;

          }
        }
      },

      //获取相关联的展馆数据
      async siteBrother(){
        let res = await siteBrother({
          TimeStamp: this.TimeStamp,
          id: this.shopid
        });
        if(res.errcode == '00000'){
          if(res.data && res.data.root && res.data.root.length > 0){
            this.siteBrotherList = res.data.root;
            this.siteBrotherTit = res.data.more;
          }
        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          if(self.tabIntroCurr == "1" && self.bagList.length>0){
            loadMore(self,function(page){
              self.initData(page);
            });
          }
        })
      },

      //获取红包活动数据
      async getActivity(){
        let res1 = await getEnvelope({
          TimeStamp: this.TimeStamp,
          openId: this.userInfo.openid,
          type: 0,
          shopId: this.shopid
        });

        if (res1.errcode == '00000' && res1.errmsg == 'SUCCESS' && res1.data.length > 0) {
          if(res1.data[0].model == 1){
            res1.data[0].takeEnvelope = 0;
            this.redEnvelNew = res1.data[0].coupon;
          }else if(res1.data[0].model == 2){
            this.$toast('红包已领取成功')
          }else {
            res1.data[0].takeEnvelope = 0;
            this.redEnvelopes = res1.data[0];
          }
        } else {
          //都江堰活动用到
          let res2 = await getUserTui({  //推荐人物
            TimeStamp: this.TimeStamp,
            openid: this.userInfo.openid,
            shopid: this.shopid
          });
          if (res2.errcode == '00000' && res2.data != null) {
            if(res2.data.type == 1){ //推荐音频
              this.recommendYear = res2.data;
            }else if(res2.data.type == 0 || res2.data.type == 2){ //推荐图片 + 推荐视频
              this.userTui = res2.data.type;
              this.recommendPerson = res2.data;
            }
          }
        }

      },

      //提醒用户重新扫码弹窗
      async getScanTip(){
        let res = await ScanTip({
          id: this.shopid,
          usernote: this.usernote,
          openid: this.userInfo.openid
        });
        if (res.errcode === "00000"){
          this.$alert({
            title: '温馨提示',
            content: '如您使用时退出了页面，可在景区内重新扫码进入',
            btnText: '知道了'
          });
        }
      },

      //提醒用户购买弹窗
      async getBuyNotice(){
        let res = await getNotice({
          TimeStamp: this.TimeStamp,
          openId: this.userInfo.openid
        });
        if (res.errcode === "00000"){
          this.buyTip = 1;
        }
      },

      //上传扫码数据
      async sendScan(lat,lng){
        let res = await uploadScan({
          openid: this.userInfo.openid,
          spotid: this.spotid,
          qid: this.qid || "",
          lat: lat || "",
          lng: lng || ""
        });
      },

      //上传浏览数据
      async sendUserBrowse(){
        this.userInfo = getStore("userInfo");
        let res = await uploadUserBrowse({
          openid: this.userInfo.openid,
          appKey: this.appKey,
        });
      },

      //请求导游分类
      async getTablist(){
        let res = await getBagTab({
          TimeStamp: this.TimeStamp,
          openid:  this.userInfo.openid,
          spotid: this.spotid
        });
        if (res.errcode === "00000"){
          this.tablist = res.data.root;

          if(this.tablist && this.tablist.length>0){
            this.cid = this.tablist[0].id;
          }
          this.initData(this.page);
        }
      },

      //请求讲解点目录
      async getCatalist(){
        let res = await getCatalogue({
          TimeStamp: this.TimeStamp,
          type: 0,
          id: this.shopid,
          name: this.inputValue
        });
        if (res.errcode === "00000"){
          this.catalogueRoot = res.data.root
        }
      },

      //导游分类列表切换
      tablistClick(cid){
        MtaH5.clickStat("spot_detail_tab");
        if(this.videoTimer != null){
          this.Audio.pause();
          clearInterval(this.videoTimer);
        }
        this.currIndex = -1;
        for(var i=0; i<this.bagList.length; i++){
          this.bagList[i].isplay = 0;
        }
        this.bag = {};

        this.$loading.show('数据加载中');
        this.loadText = '数据加载中'
        this.page = 1;
        this.bagList = [];
        this.cid = cid;

        this.initData(this.page);
      },

      //当前页面刷新景点信息
      spotLink(spotid,shopid){
        this.$router.replace({
          path: `/spot-detail?${'code'+this.code+'&spotid='+spotid+'&shopid='+shopid +'&siteid='+ this.siteid + '&sregion='+ this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
        });
        //this.$router.go(0);
        window.location.reload();

//        this.$loading.show('数据加载中');
//
//        this.spotid = spotid;
//        this.shopid = shopid;
//        this.page = 1;
//
//        this.loadText = '数据加载中'
//        this.page = 1;
//        this.bagList = [];
//        this.cid = '';
//        this.catalogueRoot = [];
//        this.catalogueCurr = 0;
//        this.tablist = [];
//
//        this.getTablist();
//        this.getCatalist();
//        this.VRlist = [];
//        this.VRtotal = 0;

      },

      //点击试听，调用试听公用方法
      listenTurlClick(ind,listType){
        MtaH5.clickStat("spot_detail_listen");
        MtaH5.clickStat('xiangqingyeshit',{'viewdetaillisten':'true'});//景区、景点》1试听弹窗》购买》支付
        MtaH5.clickStat('jingqujingdiana-1',{'1listen':'true'});//景区景点1试听》直接购买》支付
        this.lastListType = this.listType;
        this.listType = listType;

        if(listType == 'tjList'){
          listenTurl(this,ind,this.tlist)
        }else {
          listenTurl(this,ind,this.bagList)
        }

      },

      //点击购买，调用下订单公用方法
      buyVideo(ind,listType){
        MtaH5.clickStat("spot_detail_buy");
        MtaH5.clickStat('viewspotbuy',{'1viewspotbuy':'true'});//景区、景点》试听弹窗》购买》支付
        MtaH5.clickStat('jingqujingdiana-1',{'2buy':'true'});//景区景点试听》1直接购买》支付
        this.listType = listType;
        let list = listType == 'tjList' ? this.tlist[ind] : this.bagList[ind] ;
        let self = this;

        setStore("source", {"source": "index"});
        setStore("couponid", {"couponid": ""});
        self.$router.push({
          path: `/pay?${'pid='+list.id+'&cid='+self.couponid+'&shopid='+self.shopid +'&appKey='+(self.appKey)}`
        });

//        creatOrder(this,list,"",function(data){
//          if(data){
//            setTimeout(function() {
//              list.buy = 12;
//              self.bag = {};
//
//              pushOrder('dist/index.htmlJH/video-play?id='+list.id+'ANDspotid='+list.spotid+'ANDshopid='+list.shopid + 'ANDform=spot' + 'ANDTimeStamp='+ self.TimeStamp + 'ANDappKey='+ self.appKey);
//            }, 500)
//          }
//        })
      },

      buyVideo1(ind,listType){
        this.listType = listType;
        let list = listType == 'tjList' ? this.tlist[ind] : this.bagList[ind] ;
        let self = this;
        setStore("couponid", {"couponid": ""});
        self.$router.push({
          path: `/pay?${'pid='+list.id+'&cid='+self.couponid+'&shopid='+self.shopid+'&bagtype=1' +'&appKey='+(self.appKey)}`
        });

      },

      //关闭试听弹窗，购买成功修改音频状态
      closeEnd(msg){
        this.bag = msg.bag;
        if(msg.isbuy){
          if(this.listType == 'tjList'){
            this.tlist[this.index1].buy = 12;
          }else {
            this.bagList[this.index1].buy = 12;
          }
        }
      },

      //关闭活动弹窗
      closeEnvelope(msg){
        this.redEnvelopes = msg.redEnvelopes;
        this.personEnvelopes = msg.personEnvelopes;
        this.recommendPerson = msg.recommendPerson;
        this.recommendYear = msg.recommendYear;
        if(msg.redEnvelNew1){
          this.redEnvelNew = [];
          if(msg.type == 0){
            this.$toast('领取成功，购买专辑立减哟');
          }
        }
      },

      //关闭购买提醒弹窗
      closePayTip(msg){
        this.buyTip = msg;
      },

      //跳转到专辑详情页
      goVideoPlay(ind,listType,rewardShow){
        MtaH5.clickStat('jingqujingdiana-2',{'1tovideo':'true'});//景区景点1进入专辑详情》点击购买》支付
        MtaH5.clickStat('jingqujingdiana-3',{'1tovideo':'true'});//景区景点1进入专辑详情》试听》购买》支付
        MtaH5.clickStat('jingqujingdiana-4',{'1tovideo':'true'});//景区景点1进入专辑详情》试听》弹窗购买》支付
        this.listType = listType;
        let list = [];
        if(this.listType == 'myList'){
          list = this.mylist;
        }else if(this.listType == 'tjList'){
          list = this.tlist;
        }else {
          list = this.bagList;
        }
        if(rewardShow){
          this.$router.push({
            path: `/video-play-nx?${'id='+list[ind].id+'&spotid='+list[ind].spotid+'&shopid='+this.shopid+'&isback=1&form=spot&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&rewardShow=1'}`
          });
        }else {
          if((list[ind].buy!=12)&&(!list[ind].isuser)){
            MtaH5.clickStat('list_detail_button')
          }
          this.$router.push({
            path: `/video-play-nx?${'id='+list[ind].id+'&spotid='+list[ind].spotid+'&shopid='+this.shopid+'&isback=1&form=spot&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
          });
        }
      },

      //点击购买，调用下订单公用方法
      buyVideoVr(id){
        let self = this;
        setStore("source", {"source": "video"});
        setStore("couponid", {"couponid": ""});
        self.$router.push({
          path: `/pay?${'pid='+id+'&cid='+self.couponid+'&shopid='+self.shopid+'&bagtype=2'+'&appKey='+(self.appKey)}`
        });
      },

      //跳转到VR视频
      goVideoVR(id,label){
        if(label=='turn'){
          this.$router.push({
            path: `/video-vr?${'id='+id+'&shopid='+this.shopid+'&spotid='+this.spotid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&bagtype=2&label=turn'}`
          });
        }else {
          this.$router.push({
            path: `/video-vr?${'id='+id+'&shopid='+this.shopid+'&spotid='+this.spotid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&bagtype=2'}`
          });
        }
      },

      //跳转到景区视频
      goVideoPlayView(ind){
        this.$router.push({
          path: `/video-play1?${'id='+this.tlist[ind].id+'&shopid='+this.shopid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&bagtype=1'}`
        });
      },

      //跳转到景区页面
      goViewDetail(id){
        this.$router.push({
          path: `/view-detail?${'shopid='+ id +'&siteid='+ this.siteid + '&sregion='+ this.sregion  +'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
        });
      },

      //跳转到导游详情页
      goGuideInfo(id){
        MtaH5.clickStat("spot_detail_person");
        MtaH5.clickStat('jingqujingdiana',{'1guide':'true'});//景区景点1点击导游头像》个人主页购买》支付
        this.$router.push({
          path: `/guide-info?${'id='+ id + '&TimeStamp='+ this.TimeStamp +'&appKey='+(this.appKey)}`
        });
      },


      //跳转到首页
      goHome(){
        if(this.code){
          this.$router.push({
            path: `/city-site?${'code='+ this.code + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
          });
        }else if(this.res.domain){
          window.location = this.res.domain
        }else {
          MtaH5.clickStat("spot_to_home");//景点详情页面点击跳转首页
          this.$router.push({
            path: `/?${'siteid='+ this.siteid + '&sregion='+ this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
          });
        }
      },

      //显示分享海报弹窗
      showPoster(){
        MtaH5.clickStat('poster_share',{'spotdetail':'true'});
        this.posterShow = 1;
      },

      //关闭分享海报弹窗
      closePoster(msg){
        this.posterShow = msg;
      },

      //景点简介
      tabIntroCurr2(){
        this.tabIntroCurr = 2;
        MtaH5.clickStat('view_detail');
      },

      //讲解点目录
      catalogueCurr1(){
        this.catalogueCurr = 1;
        MtaH5.clickStat("catalogue");
      },

      //关注公众号
      focusFun(){
        MtaH5.clickStat("focus");//关注公众号
        this.focusEwmShow = 1;
      },

      //公众号弹窗关闭
      closeFocus(){
        this.focusEwmShow = 0;
      },
      //跳转到地图界面
      toMap(){
        this.$router.push({
          path: `/map?${'siteid='+ this.siteid + '&sregion='+ this.sregion + '&shopid='+ this.shopid + '&spotid='+ this.spotid + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
        });
      },

      showPhotoVR(imgurl,obj){
        var self = this;
        this.PSV = PhotoSphereViewer({
          container: obj,
          panorama: imgurl,
          autoload: true, //自动播放
          time_anim: 2000, //默认2000
          anim_speed: '2rpm', //默认2rpm
          navbar: false,  //不显示下面的导航栏
          overload: function(){
            self.loadPSV = true;
          }
        });
      },

      //跳转到视频专辑页面
      goVideoList(id,ind){
        this.$router.push({
          path: `/video-list?${'id='+id+'&ind='+ ind +'&shopid='+this.shopid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&bagtype=4'}`
        });
      },

    },
    watch:  {
      bag(newVal,oldVal){
        if(Object.keys(newVal).length){
          let list = this.listType == 'tjList' ? this.tlist : this.bagList ;
          listenEndOrder(this,this.index1,list);
        }
      },
    },
    components: {
      Swiper,
        AlertListenEnd,
        AlertRedEnvelope,
        AlertPersonEnvelope,
        AlertRecommendPerson,
        AlertYearPerson,
        AlertRedEnvelNew,
        AlertPayTip,
        AlertPoster,
        Focus,
        P400
    },
    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      }
    }

  }

</script>

<style scoped>
  @import "../../style/alert.css";
  @import "../../style/voice.css";
  /*.page{ padding-bottom:1.40rem; }*/
  .tab-scenic-box *{white-space: normal!important;}
  /*轮播图*/
  .swiper-con{width:100%;height: 3.85rem;}
  .swiper-box,.swiper-box .swiper-container{border-radius: 0!important;}
  .swiper-box .swiper-pagination{bottom: .4rem;}
  .icon-share{position:absolute;top:.1rem;right:.12rem;width: .51rem;height: .51rem;padding:.10rem;z-index:2;}

  .list-box{border-bottom:1px solid #e6e6e6; }
  .popularity-recommend .list-box{border-bottom: none;}

  /*语音、详情、目录切换*/
  .tab-intro {position: relative;height:1.04rem;text-align:center;color:#3c403b;background:#fff;border-radius:.3rem .3rem 0 0;margin-top:-.3rem;z-index: 1;}
  .tab-intro img {display: block;width:.48rem;height:.48rem;margin:.16rem auto 0;}
  .tab-intro img.scenic-icon-curr{display: none;}
  .tab-intro span {margin-top:.06rem;font-size:.2rem;font-weight:bold;color: #3c403b;}
  .tab-intro .flex.curr .scenic-icon-curr {display: block;}
  .tab-intro .flex.curr .scenic-icon {display: none;}
  .tab-intro .flex.curr span {color: #a33737;}

  /*导游分类*/
  .list-tab {width: 100%;height:.82rem;line-height:.82rem;background:#fff;border-bottom:1px solid #f3f3f3;white-space:nowrap!important;overflow-x: auto;}
  .list-tab .flex {position:relative;display: inline-block;width:22%!important;height:.8rem;line-height:.8rem;text-align:center;font-size:.28rem;color:#666;  }
  .list-tab .flex.curr{color: #000;}
  .list-tab .flex.curr:after{content:'';position:absolute;bottom:0;left:50%;right:0;width:.24rem;height:.12rem;background:#a33737;border-radius: .12rem .12rem 0 0;transform: translateX(-50%);z-index:1;}
  .special .list-tab{display:-webkit-box;display:box;}
  .special .list-tab .flex{display:block;width:initial;-webkit-box-flex:1;box-flex:1;}

  /*官方推荐*/
  .popularity-recommend-title{width:100%;height:.96rem;line-height:.96rem;padding-left:.24rem;font-size:.3rem;color:#666;font-weight:bold;}


  /*新版景区景点详情*/
  .scenic-padding{padding:.26rem .24rem;background:#fff;font-weight:bold;color:#555;}
  .scenic-details-box{position:relative;background: #fff;}
  .scenic-details-box.curr .scenic-details{height:auto;}
  .scenic-details-title{position:relative;font-size:.3rem;}
  .scenic-details-info{line-height:.4rem;font-size:.26rem;font-weight: normal;}
  .toggle-slide{display:none;position:relative;width:100%;height:.4rem;line-height:.4rem;padding:.1rem 0;color:#a33737;box-shadow:0 -.06rem .25rem #fff;}
  .toggle-slide image.icon-down-info{position:absolute;top:50%;left:50%;width:.33rem;height:.15rem;transform:translate(-50%,-50%);}
  .scenic-details-box.curr .toggle-slide image{-webkit-transform:rotate(180deg);transform:rotate(180deg);}
  .view-video-btn{position: absolute;top:50%;left:50%;width: .6rem;height: .6rem;margin: -.3rem 0 0 -.3rem;z-index: 9;}

  /*VR真人讲解*/
  .video-vr{padding: 0 .26rem .4rem;}
  .video-vr-con{width: 100%;border-radius: .1rem;box-shadow: 0 0 .25rem #f7f7f7;overflow: hidden;}
  .video-vr-tit{width:100%;height: .96rem;font: bold .28rem/1.03rem "Microsoft YaHei";color: #3d3d3d;overflow: hidden;}
  .video-vr-tit .fr{font:normal .24rem/1.03rem "Microsoft YaHei";color: #555;}
  .video-vr-top{ display: block; position:relative;width: 100%;height: 3rem;border-radius: .1rem .1rem 0 0;overflow: hidden;}
  .video-vr-img{position:absolute;top:0;left:0;width: 100%;height: 100%;border-radius: .1rem .1rem 0 0;object-fit: cover;}
  .video-vr-mask{position: absolute;z-index: 1;top:0;left: 0;width: 100%;height: 100%;background: rgba(0,0,0,.52);}
  .video-vr .icon_360{position: absolute;z-index: 1;top:.12rem;right:.12rem;width: 1.36rem;height: auto;}
  .video-vr .video-tit{position: relative;z-index: 1;width:100%;height:.75rem;padding: 0 1.6rem 0 .2rem;font: .26rem/.75rem "Microsoft YaHei";color: #fff;}
  .video-vr-btn{position: absolute;z-index:1;top:50%;left:50%;width: 1.02rem;height: auto;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}
  .video-vr-txt{position: absolute;z-index: 1;bottom: .14rem;font: bold .2rem "Microsoft YaHei";color: #fff;}
  .video-vr-txt.num{ left:.2rem;}
  .video-vr-txt.spot{ right:.2rem;}
  .video-vr-bot{position:relative;width:100%;height: .98rem;padding: 0 .2rem;}
  .video-vr-guide{width: .58rem;height: .58rem;margin-top:.2rem;border-radius: 50%;object-fit: cover;}
  .video-vr-name{max-width:70%;margin-left: .15rem;font: .26rem/.98rem "Microsoft YaHei";color: #000;}
  .video-vr-bot .buy-btn{top: 50%;transform: translateY(-50%);}

  .video-vr-con1 .video-vr-top{ margin-top: .24rem; width: 48.2%; }
  .video-vr-con1 .icon_360{ top: 42%; right: 50%; margin-right: -.68rem; }
  .video-vr1{ padding: 0 ;}
  .video-vr1 .video-vr-tit{ width: auto; padding: .2rem .24rem 0; height: .36rem; line-height: .36rem; }
  .video-vr1 .video-vr-tit .fr{ line-height: .36rem; }
  .video-vr1 .list-box:last-child{ border-bottom: none; }

  /*轮播图内跳转首页按钮*/
  .link-btn{position: fixed;z-index:2;right:0;top: 2rem;height: .6rem;padding:0 .28rem;font: .28rem/.6rem "Microsoft YaHei";color:#fff;border-radius: .3rem 0 0 .3rem;background: rgba(0,0,0,.7);}

  /*关注*/
  .focus{width:100%;height: .75rem;background: rgba(0,0,0,.8);color: #fff;}
  .icon-focus{float: left;width: auto;height: .52rem;margin:.115rem .22rem 0 .27rem; }
  .focus-txt{float: left;width:63%;font: .24rem/.75rem "Microsoft YaHei";letter-spacing: .02rem; }
  .focus-btn{float: right;width:1.15rem;height: .5rem;margin-top:.125rem;margin-right:.1rem;border: 1px solid #a33737;color: #fff;font: .24rem/.5rem "Microsoft YaHei";color: #fff;
    text-align: center;border-radius: .3rem;-webkit-animation: focus 1.2s linear infinite;animation: focus 1.2s linear infinite;-webkit-transform: scale(.96);transform: scale(.96);}
  @-webkit-keyframes focus {
    0%{-webkit-transform: scale(.96);}
    20%{-webkit-transform: scale(1);}
    40%{-webkit-transform: scale(.96);}
    60%{-webkit-transform: scale(1);}
    80%{-webkit-transform: scale(.96);}
    100%{-webkit-transform: scale(1);}
  }
  @keyframes focus {
    0%{transform: scale(.96);}
    20%{transform: scale(1);}
    40%{transform: scale(.96);}
    60%{transform: scale(1);}
    80%{transform: scale(.96);}
    100%{transform: scale(1);}
  }

  /*短视频*/
  .video-con .video-vr-tit{ padding: 0 .24rem; }
  .video-con-box{ padding: 0 0 .24rem .16rem; overflow-x: auto; }
  .video-con-list{ width: 8.32rem; padding-right: .24rem; }
  .video-con-list li{ position: relative; float: left; margin-left: .08rem; width: 2rem; height: 3rem; overflow: hidden; border-radius: .13rem; }
  .video-con-list li .icon{ position: absolute; left: 50%; top: 50%; width: .56rem; height: .56rem; transform: translate(-50%,-50%); }
  .video-con-name{ position: absolute; left: 0; right: 0; bottom: 0; z-index: 1; padding: 0 .12rem; height: .59rem; font-size: .2rem; line-height: .64rem; text-align: center; color: #fff; background: url(../../assets/a_01.png) repeat-x; }
  .video-con-list .last p{ position: absolute; left: 0; right: 0; top: 50%; font-size: .24rem; line-height: .34rem; text-align: center; color: #fff; transform: translateY(-50%);   }

  /*其他展馆*/
  .jc-tit{width: 100%;height: 1.12rem;padding:0 .3rem;font: bold .32rem/1.12rem "Microsoft YaHei";color: #3d3d3d;}
  .jc-tit .fr{ position: relative; padding-right: .25rem; font:normal .24rem/1.03rem "Microsoft YaHei";color: #555;}
  .jc-tit .fr img{ position: absolute; top: .4rem; right: 0; width: .13rem; height: auto; }
  .zg-ul{width: 100%;height: 2.44rem;padding: 0 .3rem;white-space: nowrap;overflow-x: auto;}
  .zg-ul li{position:relative;display:inline-block;width: 2.14rem;height: 100%;margin-right: .14rem;}
  .zg-ul li img{width: 100%;height: 1.68rem;border-radius: .08rem;object-fit: cover;}
  .zg-ul li p{margin-top: .12rem;font: .28rem/1.2 "Microsoft YaHei";color: #3d3d3d;text-align: center;white-space: nowrap!important; }
  .brothers .list-box:last-of-type{ border-bottom: none; }
  .brothers .load-tip{ height: 0; padding: 0; overflow: hidden; }

  .price-text .sellprice{ font-size: .22rem; color: #999; text-decoration: line-through; }


  .new .list-tab2 .flex{ width: 49.5%!important;}
  .new .list-tab .flex.curr{ color:#a33737; }
  .new .list-tab .flex.curr:after { width: 40%; height: .03rem; border-radius: .12rem .12rem 0 0; }
  .new .scenic-details-title{font-size:.28rem;}
  .new .list-img img.icon-tx{border-radius:0;}
  .new .list-name{padding-top: .1rem;}
  .new .list-name span{margin-top:.1rem;font-size: .3rem;background: transparent;color:#a33737;padding-left: 0;margin-left: 0;}
  .new .list-group{margin-top: .15rem;font-weight:normal;}
  .new .list-group span.label-type{ margin-top: 0; color: #999; background: #e3e3e3; border-radius: 0; }
  .new .btn.buy-btn{background: #a33737;border-radius: .1rem;bottom: 0;}
  .new .list-box{border-bottom:none;}
  .new .swiper-con .swiper-box .swiper-pagination{bottom: .2rem;}

</style>



// WEBPACK FOOTER //
// src/page/spot-detail/spot-detail-nx.vue